import * as React from "react";
import { get } from "lodash";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import { Route, Switch, Redirect } from "react-router-dom";
import { Box } from "grid-styled";
import { Helmet } from "react-helmet";
import join from "../utils/join-path";
import JobHeader from "./JobHeader";
import { TabBar, TabLink } from "./tabs";
import UpdateJobMutation from "../mutations/UpdateJob";
import ChangeFranchiseModal from "./ChangeFranchiseModal";
import ServiceHistories from "./services/ServiceHistories";
import JobSummary from "./JobSummary";
import JobDetails from "./JobDetails";
import Contracts from "./Contracts";
import JobQuery from "../queries/Job";
import CenteredLoader from "./CenteredLoader";

class Job extends React.Component {
  state = {
    isFranchiseChangeModalOpen: false,
    redirectToJobs: false
  };

  handleFranchiseClick = () => {
    this.setState({ isFranchiseChangeModalOpen: true });
  };

  handleFranchiseChange = values => {
    this.props.updateFranchise(values).then(() => {
      this.setState({ isFranchiseChangeModalOpen: false });
    });
  };

  handleJobArchive = () => {
    const { job } = this.props;

    if (job.archived) {
      return this.props.unarchiveJob();
    }

    return this.props.archiveJob().then(() => {
      this.setState({ redirectToJobs: true });
    });
  };

  render() {
    const { loading, job, match } = this.props;
    const isAdmin = !!match.path.match(/^\/admin/);

    if (loading) return <CenteredLoader />;
    if (this.state.redirectToJobs)
      return <Redirect to={match.url.replace(/\/\d+\/?$/, "")} />;

    const pageTitle = [job.contractNumber, job.contact.lastName]
      .filter(el => typeof el === "string" && el.trim() !== "")
      .join(" - ");

    return (
      <Box p={3}>
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
        <JobHeader
          job={job}
          contractsPath={join(match.url, "/contracts")}
          onFranchiseClick={isAdmin ? this.handleFranchiseClick : undefined}
        />
        <TabBar bordered>
          <TabLink exact to={match.url}>
            Job Summary
          </TabLink>
          <TabLink to={join(match.url, "/details")}>Details</TabLink>
          <TabLink to={join(match.url, "/services")}>Service Histories</TabLink>
          <TabLink to={join(match.url, "/contracts")}>Contracts</TabLink>
        </TabBar>
        <Switch>
          <Route
            exact
            path={match.path}
            render={routeProps => (
              <JobSummary
                {...routeProps}
                job={job}
                onArchive={this.handleJobArchive}
              />
            )}
          />
          <Route path={`${match.path}/details`} component={JobDetails} />
          <Route path={`${match.path}/services`} component={ServiceHistories} />
          <Route
            path={`${match.path}/contracts`}
            render={props => <Contracts {...props} job={job} />}
          />
        </Switch>
        {isAdmin && (
          <ChangeFranchiseModal
            isOpen={this.state.isFranchiseChangeModalOpen}
            onClose={() => this.setState({ isFranchiseChangeModalOpen: false })}
            onSubmit={this.handleFranchiseChange}
            franchiseId={get(this.props.job.franchise, "id")}
          />
        )}
      </Box>
    );
  }
}

const ArchiveJobMutation = gql`
  mutation ArchiveJob($id: ID!) {
    archiveJob(id: $id) {
      id
    }
  }
`;

const UnarchiveJobMutation = gql`
  mutation UnarchiveJob($id: ID!) {
    unarchiveJob(id: $id) {
      id
    }
  }
`;

const enhance = compose(
  graphql(JobQuery, {
    options: ({ match: { params: { jobId } } }) => ({
      variables: { jobId: parseInt(jobId, 10) }
    }),
    props: ({ data: { loading, job } }) => ({
      loading,
      job
    })
  }),
  graphql(UpdateJobMutation, {
    props: ({ ownProps: { match: { params: { jobId } } }, mutate }) => ({
      updateFranchise({ franchiseId }) {
        return mutate({
          variables: { id: jobId, input: { franchiseId } }
        });
      }
    }),
    options: {
      refetchQueries: ["JobQuery"]
    }
  }),
  graphql(ArchiveJobMutation, {
    props: ({ ownProps: { match: { params: { jobId } } }, mutate }) => ({
      archiveJob() {
        return mutate({
          variables: { id: jobId }
        });
      }
    }),
    options: {
      refetchQueries: ["JobQuery"]
    }
  }),
  graphql(UnarchiveJobMutation, {
    props: ({ ownProps: { match: { params: { jobId } } }, mutate }) => ({
      unarchiveJob() {
        return mutate({
          variables: { id: jobId }
        });
      }
    }),
    options: {
      refetchQueries: ["JobQuery"]
    }
  })
);

export default enhance(Job);



// WEBPACK FOOTER //
// ./src/components/Job.js